import { cn } from "@/cn";
import { COMPANY_TABS, type CompanyTabId } from "./company-hero";

export function CompanyTabs({
  active,
  onChange,
}: {
  active: CompanyTabId;
  onChange: (tab: CompanyTabId) => void;
}) {
  return (
    <div
      role="tablist"
      className="flex max-w-full flex-wrap gap-1 border-b border-border"
    >
      {COMPANY_TABS.map((tab) => {
        const selected = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab.id)}
            className={cn(
              "-mb-px border-b-2 px-3 py-2.5 text-sm font-medium transition-colors",
              selected
                ? "border-brand text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
